module.exports = __webpack_public_path__ + "img/beer_id-14.2d6c38f9.png";